$(function () {
  const $tabsBlocks = $('[data-tabs]');

  const sliderSettings = {
    slidesToShow: 1,
    arrows: true,
    dots: false,
    swipeToSlide: true,
    touchThreshold: 10,
    infinite: false,
    mobileFirst: true,
    adaptiveHeight: true,
    //prevArrow: '<div class="b-slick-arrow b-slick-arrow__prev"><svg viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M17 33L0 17 17 1l2 2L6 17l13 14-2 2z"/></svg></div>',
    //nextArrow: '<div class="b-slick-arrow b-slick-arrow__next"><svg viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M3 1l17 16L3 33l-2-2 13-14L1 3l2-2z"/></svg></div>',
    prevArrow:'<div class="b-slider-arrows__prev"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
    nextArrow:'<div class="b-slider-arrows__next"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
    responsive: [
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 2,
          adaptiveHeight: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
        },
      },
    ]
  };
  if($tabsBlocks.length > 0 && $('.landing-edit-mode').length < 1) {
    $tabsBlocks.each(initTabs);
  }

  function getTabTarget(tab) {
    var fullLink = tab.dataset.tabsLink;
    return fullLink.substr(fullLink.indexOf("#"));
  }

  function initTabs() {
    const $this = $(this);

    const tabsLinks = $('[data-tabs-link]', $this);

    const tabContentId = [...tabsLinks].map(el => getTabTarget(el)).join(',');

    $(tabContentId).wrapAll('<div class="b-tabs-list"></div>');

    tabsLinks
      .removeClass('is-active')
      .eq(0)
      .addClass('is-active');
    const targetFull = tabsLinks.eq(0).data('tabs-link');
    const target =  targetFull.substr(targetFull.indexOf("#"));

    enableTab(target);

    $this.addClass('tabs-init');

    $('[data-tabs-links]', $this).slick(sliderSettings);
  }

  function enableTab(tab) {
    $(tab)
      .addClass('is-active')
      .siblings()
      .removeClass('is-active');
  }

  $(document).on('click', '[data-tabs-link]', function (e) {
    e.preventDefault();

    const target = getTabTarget(this);

    $(this)
      .addClass('is-active')
      .siblings()
      .removeClass('is-active');

    enableTab(target);
  });

  // функция для переинициализации в блочном редакторе
  window.reInitTabs = () => {
    $('[data-tabs]').each(initTabs);
  };
});
